import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202512",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 49879,
  clicks: 1028,
  adsSpendDollars: 2654,
  budgetDollars: 2700,
  salesDollars: 13670,
  bestEstimateRoas: 5.15,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 32,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
